module.exports = {
      id: "1660622f366d98f47f57a0ad6b4284f3roofShape-pyramid.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#1660622f366d98f47f57a0ad6b4284f3roofShape-pyramid.svg",
      toString: function () {
        return this.url;
      }
    }